import React, { useState } from 'react';
import WizardHeader from './components/WizardHeader';
import Step1Selection from './components/Step1Selection';
import Step2Parameters from './components/Step2Parameters';
import Step3Results from './components/Step3Results';
import DisclaimerModal from './components/DisclaimerModal';
import './App.css';

function App() {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedDiseases, setSelectedDiseases] = useState([]);
  const [formData, setFormData] = useState({});

  const [confirmReset, setConfirmReset] = useState(false);

  const resetAll = () => {
    if (!confirmReset) {
      setConfirmReset(true);
      setTimeout(() => setConfirmReset(false), 4000);
      return;
    }
    setSelectedDiseases([]);
    setFormData({});
    setCurrentStep(1);
    setConfirmReset(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div style={{ maxWidth: '960px', margin: '30px auto', borderRadius: '16px', boxShadow: '0 8px 40px rgba(0,0,0,0.12)', overflow: 'hidden', background: 'white', paddingBottom: '40px' }}>
      <DisclaimerModal />
      <div className="app-header">
        <div className="app-header-inner" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative', zIndex: 10 }}>
          <div>
            <h1>⚕️ Platformă Evaluare Medico-Psihosocială Handicap</h1>
            <p>Conform Anexei 1 – Ordinul MM 2300/2025</p>
          </div>
          <button 
            onClick={resetAll} 
            className="btn no-print" 
            style={{ 
              background: confirmReset ? '#dc3545' : 'rgba(255,255,255,0.2)', 
              color: 'white', 
              border: confirmReset ? 'none' : '1px solid rgba(255,255,255,0.4)', 
              padding: '8px 16px', 
              fontSize: '13px',
              transition: 'all 0.2s ease'
            }}
          >
            {confirmReset ? "⚠️ Sigur? (Șterge Tot)" : "🔄 Resetare Nouă"}
          </button>
        </div>
      </div>

      <div style={{ padding: '30px 36px' }}>
        <WizardHeader currentStep={currentStep} setStep={setCurrentStep} />

        {currentStep === 1 && (
          <Step1Selection 
            selectedDiseases={selectedDiseases} 
            setSelectedDiseases={setSelectedDiseases} 
            onNext={() => setCurrentStep(2)} 
          />
        )}

        {currentStep === 2 && (
          <Step2Parameters 
            selectedDiseases={selectedDiseases} 
            formData={formData} 
            setFormData={setFormData} 
            onPrev={() => setCurrentStep(1)} 
            onNext={() => setCurrentStep(3)} 
          />
        )}

        {currentStep === 3 && (
          <Step3Results 
            selectedDiseases={selectedDiseases} 
            formData={formData} 
            onPrev={() => setCurrentStep(2)} 
          />
        )}
      </div>

      <button 
        onClick={scrollToTop} 
        className="btn-float no-print" 
        title="Mergi sus"
      >
        ⬆️
      </button>
    </div>
  );
}

export default App;
